module.exports = __webpack_public_path__ + "static/img/1000000466.8805c685.jpg";